import { newrelic } from "@jti/fe-clients";
import { getConfig } from "@jti/fe-common";
import type { CasCustomAttrsApiContract } from "@jti/rest-api-types";

import { createLegacyApiWarningAttributes, getIsEvo, getUser } from "../../../utils";

import { UserCustomAttrsApiEvo } from "./UserCustomAttrsApiEvo/UserCustomAttrsApiEvo.v5";

import { CasCustomAttrsApiLegacy } from "./CasCustomAttrsApiLegacy";

export class CasCustomAttrsApi {
  static init(): CasCustomAttrsApiContract {
    const config = getConfig();
    const user = getUser();

    if (config.USE_EVO_ONLY) {
      return new UserCustomAttrsApiEvo({
        baseUrl: config.EVO_DOMAIN,
        recaptchaId: config["X-RECAPTCHA-ID"],
        tenantToken: config.EVO_TENANT,
        ciamToken: user.ciam_token,
        userUuid: user.uuid || "",
      });
    }

    if (getIsEvo(config.CAS_URL)) {
      return new UserCustomAttrsApiEvo({
        baseUrl: config.CAS_URL,
        recaptchaId: config["X-RECAPTCHA-ID"],
        tenantToken: config.CAS_X_DES_AK_TENANT_TOKEN,
        ciamToken: user.ciam_token,
        userUuid: user.uuid || "",
      });
    }
    newrelic.sendWarning(
      "CasCustomAttrsApiLegacy initialized - legacy API client in use",
      createLegacyApiWarningAttributes(config, config.CAS_URL)
    );

    return new CasCustomAttrsApiLegacy(
      config.CAS_URL,
      config.CAS_X_DES_AK_TENANT_TOKEN,
      user.ciam_token,
      user.uuid || ""
    );
  }
}
